import _           from 'lodash'
import moment      from 'moment'

export dateFormat = 'YYYY-MM-DD'

emailRegex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]{2,}$/

# string
export isValidEmail = (email) ->
  emailRegex.test(email)

# object
export removeFalsyAttrs = (obj) ->
  new ->
    for attr, val of obj
      @[attr] = val if val?
    @

export removeEmptyAttrs = (obj) ->
  new ->
    for attr, val of obj
      @[attr] = val unless [undefined, null, '', [], {}].includes(val)
    @

# boolean
export translateBool = (bool) -> if bool then 'ano' else 'ne'

# date
export momentComparator = (moment1, moment2) => if moment1.isBefore(moment2) then -1 else 0

export formatDate = (mmnt) -> mmnt.format(dateFormat)

export dateAfterNDays = (startDate, n) -> startDate.clone().add(n, 'days')

export datesInInterval = (start, end) ->
  first = current = start.startOf('day')
  dates = [first]

  loop
    current = current.clone().add(1, 'day')
    break if current.isAfter(end)
    dates.push(current)

  dates

# location
export currentLocation = ->
  { pathname, hash, search } = window.location

  { pathname, hash, query: parseQueryString(location.search) }

export parseQueryString = (queryString) ->
  _.fromPairs(queryString.replace('?', '').split('&').map (param) -> param.split('='))
